import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexHelper',
  setup(__props) {

const helperBorders = defineAsyncComponent(() => import("@/components/theme/uikits/helper/helperBorders.vue"))
const helperDisplays = defineAsyncComponent(() => import("@/components/theme/uikits/helper/helperDisplays.vue"))
const backgroundColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/backgroundColors.vue"))
const borderColor = defineAsyncComponent(() => import("@/components/theme/uikits/helper/borderColor.vue"))
const ImagesSizes = defineAsyncComponent(() => import("@/components/theme/uikits/helper/ImagesSizes.vue"))
const fontStyle = defineAsyncComponent(() => import("@/components/theme/uikits/helper/fontStyle.vue"))
const textColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/textColors.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Helper Classes"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(helperBorders)),
        _createVNode(_unref(helperDisplays)),
        _createVNode(_unref(backgroundColors)),
        _createVNode(_unref(borderColor)),
        _createVNode(_unref(ImagesSizes)),
        _createVNode(_unref(fontStyle)),
        _createVNode(_unref(textColors))
      ])
    ])
  ], 64))
}
}

})